import request from '@/api/http';

/** 超过此行数时，导出前需二次确认 */
export const EXPORT_LARGE_ROW_THRESHOLD = 10000;

/**
 * 当 total 超过 EXPORT_LARGE_ROW_THRESHOLD 时弹出确认；未超限则直接通过。
 * 用户取消第二次确认时 Promise reject。
 *
 * @param {import('vue').default} vm 组件实例（this）
 * @param {number} total 与导出同条件下的总条数
 * @returns {Promise<void>}
 */
export function confirmExportLargeRows(vm, total) {
  const n = Number(total) || 0;
  if (n <= EXPORT_LARGE_ROW_THRESHOLD) {
    return Promise.resolve();
  }
  const countStr = n.toLocaleString();
  return vm.$confirm(
    vm.$t('common.exportLargeMessage', { count: countStr }),
    vm.$t('common.exportLargeTitle'),
    {
      confirmButtonText: vm.$t('common.confirm'),
      cancelButtonText: vm.$t('common.cancel'),
      type: 'warning'
    }
  );
}

/**
 * 通用报表导出工具
 * 发起 blob 请求 → 触发浏览器下载
 *
 * @param {string}   url      后端导出接口路径（不含 /api 前缀）
 * @param {object}   params   查询参数
 * @param {string}   fallbackName  兜底文件名（后端未返回 Content-Disposition 时使用）
 * @returns {Promise<void>}
 */
export function exportExcel(url, params, fallbackName = '报表导出.xlsx') {
  return request({
    url,
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 120000
  }).then(res => {
    const blob = new Blob([res], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fallbackName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  });
}
